import { Reveal } from "@/components/Reveal";
import { useLeadModals } from "@/components/LeadModals";
import { OfferCountdown } from "@/components/home/OfferCountdown";

export const CtaBand = () => {
  const { openTrial, openDemo } = useLeadModals();

  return (
    <section className="bg-gradient-to-r from-hero-blue to-hero-gold py-24 sm:py-28" data-testid="cta-band-section">
      <div className="mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8">
        <Reveal>
          <h2 className="font-display text-4xl font-bold uppercase leading-[1.02] tracking-tight text-white drop-shadow-md sm:text-5xl lg:text-6xl">
            Stop Waiting Weeks for Videos.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mx-auto mt-6 max-w-2xl text-base font-medium text-white/95 sm:text-lg">
            360° room tours, drone flights & promo clips — custom-made for your company.
            $2,000/month. No setup fees. Cancel anytime.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
            <button
              onClick={openTrial}
              data-testid="cta-band-trial"
              className="rounded-md bg-hero-black px-8 py-4 font-display text-lg font-semibold uppercase tracking-wide text-white shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              Start First Month — 50% Off
            </button>
            <button
              onClick={openDemo}
              data-testid="cta-band-demo"
              className="rounded-md border-2 border-white bg-white/10 px-8 py-4 font-display text-lg font-semibold uppercase tracking-wide text-white backdrop-blur transition-all duration-300 hover:-translate-y-1 hover:bg-white hover:text-hero-black"
            >
              Book 15-Min Demo
            </button>
          </div>
        </Reveal>
        <Reveal delay={0.4}>
          <div className="mt-8 flex justify-center">
            <OfferCountdown dark />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
